module.exports = __webpack_public_path__ + "img/case_title.8aebec55.png";